import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { AccessTokenProvider } from "./contexts/AccessTokenContext";
import i18n from "./i18n";
import { router } from "./router";
import AntdLocaleProvider from "./utils/antdlocaleprovider";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AccessTokenProvider>
      <I18nextProvider i18n={i18n} defaultNS={"menus"}>
        <AntdLocaleProvider>
          <RouterProvider router={router} />
        </AntdLocaleProvider>
      </I18nextProvider>
    </AccessTokenProvider>
  </React.StrictMode>
);
